<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('receipts_list_title')}}
                    <v-spacer></v-spacer>
                    <downloadExcel
                            class            = "btn"
                            :fetch           = "fetchAll"
                            :fields          = "excelFields"
                            name="users.xls"
                    >
                        <v-btn
                                icon
                                small
                        >
                            <v-icon right dark>mdi-file-excel</v-icon>
                        </v-btn>
                    </downloadExcel>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('receipts_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <div class="d-flex justify-start mb-6">
                            <v-text-field
                                    v-model="createdAtRengeLable"
                                    label="بازه درخواست"
                                    class="mx-4 pa-1"
                                    id="filters_created_at"
                                    readonly
                                    clearable
                                    @click:clear="resetCreatedAtRenge()"
                            ></v-text-field>
                            <date-picker
                                    v-model="filters.created_at.value"
                                    range
                                    clearable
                                    format="X"
                                    display-format="jMMMM jD"
                                    element="filters_created_at"
                            />
                            <v-select
                                    clearable
                                    v-model="filters.status.value"
                                    label="وضعیت پرداخت"
                                    :items="payStatusOptions"
                                    item-text="value"
                                    item-value="key"
                                    class="mx-4 pa-1"
                            ></v-select>
                        </div>

                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.sub_total="{item}">
                        {{$t('display_price', { price : $n(item.sub_total || 0)})}}
                    </template>
                    <template #item.discount="{item}">
                        {{$t('display_price', { price : $n( item.discount || 0)})}}
                    </template>
                    <template #item.tax_due="{item}">
                        {{$t('display_price', { price : $n( item.tax_due || 0)})}}
                    </template>
                    <template #item.total_due="{item}">
                        {{$t('display_price', { price : $n(item.total_due || 0)})}}
                    </template>
                    <template #item.paid_status="{item}">
                        <v-chip
                                small
                                class="ma-2"
                                :color="item.paid_at ? 'success' : 'error'"
                                text-color="white"
                        >
                            {{$t(item.paid_at ? 'paid' : 'not_paid')}}
                        </v-chip>

                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top v-if="true || userCan('logs_list')">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Logs', query : { filters : [{column_name : 'receipt_id', operand : 'IsEqualTo', value : item.id}]}}"
                                        class="no-decoration"
                                >
                                    <v-icon v-bind="attrs"
                                            v-on="on"
                                    >mdi-math-log</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('logs')}}</span>
                        </v-tooltip>

                    </template>
                </v-data-table>
            </v-card>
        </div>
    </section>
</template>

<script>
    import RequestList from "../services/RequestList";
    import Service from "../services/ReceiptsService";
    import downloadExcel from "vue-json-excel";
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],

        components: {
            downloadExcel
        },
        computed: {
            payStatusOptions(){
                return Object.keys(this.$t("receipt_status")).map(key => {
                    return {
                        key,
                        value: this.$t("receipt_status")[key]
                    }
                });
            },
            createdAtRengeLable(){
                if(!this.filters.created_at.value) return null;

                let fromLabel = this.filters.created_at.value[0] ? `${this.getJalaliDate(this.filters.created_at.value[0] * 1000, 'jD jMMM jYY')} ~ ` : '';
                let toLabel = this.filters.created_at.value[1] ? `${this.getJalaliDate(this.filters.created_at.value[1] * 1000, 'jD jMMM jYY')}` : '';

                return [fromLabel, toLabel].join(' ').trim();
            },
        },

        watch: {
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(typeof filter.value != 'undefined'){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            }
        },
        data() {
            return {
                loading : false,
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('sub_total'),
                        value: 'sub_total'
                    },
                    {
                        text: this.$t('discount'),
                        value: 'discount'
                    },
                    {
                        text: this.$t('tax_due'),
                        value: 'tax_due'
                    },
                    {
                        text: this.$t('total_due'),
                        value: 'total_due'
                    },
                    {
                        text: this.$t('paid_status'),
                        value: 'paid_status'
                    },
                    {
                        text: this.$t('description'),
                        value: 'description'
                    },
                    {
                        text: this.$t('actions'),
                        value: 'actions'
                    }
                ],
                excelFields : {
                    'ایجاد شده در' : {
                        field: 'created_at',
                        callback: (value) => {
                            return this.getJalaliDate(value * 1000, 'jYYYY-jMM-jDD HH:mm');
                        }
                    },
                    "مبلغ کل" : 'sub_total',
                    'مالیات' : 'tax_due',
                    'جمع کل' : 'total_due',
                    'وضعیت پرداخت' : {
                        callback: (item) => {
                            return this.$t(item.paid_at ? 'paid' : 'not_paid');
                        }
                    },
                    'توضیحات' : 'description'

                },
                filters : {
                    created_at : {
                        column_name : 'created_at',
                        operand : 'Between',
                        value : undefined
                    },
                    status : {
                        column_name : 'status',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                items : [],
                item : null,
            }
        },
        methods: {
            async fetch() {
                this.loading = true;
                
                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);
                
                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.receipts;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async fetchAll() {
                this.loading = true;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');

                try {
                    let {data} = await Service.list(requestList);
                    return data.value.receipts;
                } finally {
                    this.loading = false;
                }
            },
            getStatusColor(receipt){
                let color = null;
                switch (receipt.status){
                    case 'pending' :
                        color = 'warning';
                        break;
                    case 'paying' :
                        color = null;
                        break;
                    case 'failed' :
                        color = 'error';
                        break;
                    case 'paid' :
                        color = 'success';
                        break;
                }
                return color;
            },
            resetCreatedAtRenge() {
                this.filters.created_at.value = undefined;
            }
        }

    }
</script>